export const environment = {
  production: false,
  apiUrl: 'https://gmslrjsapitest.clavisco.com',
  name: 'Servicios de Integracion RJ - Sislocar Staging',
  env: 'Staging'
};
